import React from 'react'
import cn from 'classnames'
import { Field } from 'redux-form'
import InputField from '../../../../forms/InputField'
import Button from '../../../../forms/Button'
import PadlockRecoverIcon from './PadlockRecoverIcon'
import Warning from 'notifications/Warning';
import CloseIcon from "../../../../billing/CurrentDue/MergePurchasesModal/CloseIcon";
import CircleLoader from '../../../../common/CircleLoader'

import styles from './styles.module.css'

const phoneNumberValidate = value =>
  value && !/^\d{10}$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined

const InputMdn = ({ mdn, onChange, handleChangeScreen, closeModal, loading }) => {
  return (
    <div className={styles.content}>
      <div className={styles.box}>
        <CloseIcon className={styles.close} onClick={closeModal} />
        <header className={styles.header}>
          <PadlockRecoverIcon />
        </header>
        <main className={styles.container}>
          <p className={cn('p_basic', styles.text)}>
            Please enter your Wing phone number to receive a verification code.
          </p>
          <div className={styles.formWrapper}>
            <div
              className={styles.form}
            >
              <Field
                type="tel"
                onChange={onChange}
                name="target_mdn"
                component={InputField}
                label="Phone Number"
                validate={phoneNumberValidate}
              />
              <Button
                className={styles.sendCodeBtn}
                onClick={handleChangeScreen}
                disabled={!mdn || (mdn && phoneNumberValidate(mdn))}
              >
                Send code
              </Button>
            </div>
          </div>
          {loading && (
            <div className={styles.loaderWrapper}>
              <CircleLoader showLoader={loading} />
            </div> 
          )}
        </main>
        <div className={styles.errorWrapper}>
          {mdn &&
            <Warning name="login" />
          }
        </div>
      </div>
    </div>
  )
}

export default InputMdn

